import {
  CREATE_LOYALTY_PROGRAM,
  FETCH_LOYALTY_PROGRAM,
  UPDATE_LOYALTY_PROGRAM,
} from './constants';

const loyalty = (state = {}, action) => {
  switch (action.type) {
    case FETCH_LOYALTY_PROGRAM:
    case UPDATE_LOYALTY_PROGRAM:
    case CREATE_LOYALTY_PROGRAM:
      return action.payload;
    default:
      return state;
  }
};

export default loyalty;
